const DEEPLINK_MAP = {
  flyy_rewards: { name: "rewards" },
  flyy_history: { name: "history" },
  flyy_wallet: { name: "wallet" },
  flyy_account: { name: "account" },
  flyy_transactions: { name: "transactions" },
  flyy_redeem: { name: "redeem" },
  flyy_gift_cards: { name: "gift_cards" },
  flyy_game_zone: { name: "game_zone" },
  flyy_quiz_zone: { name: "quiz_zone" },
  flyy_poll_zone: { name: "poll_zone" },
  flyy_survey_zone: { name: "survey_zone" },
  flyy_trivia_zone: { name: "trivia_zone" },
  flyy_referrals: { name: "referrals" },
  flyy_tournament: { name: "tournament" },
  "apps/quiz_history": { name: "quiz_history" },
  "apps/stamp_campaign_new": { name: "stamp_campaign" },
  "apps/flyy_quiz_list": { name: "quiz_zone" },
  "apps/flyy_quiz_questions": { name: "quiz_questions" },
  "apps/flyy_custom_quiz_questions": { name: "quiz_details_custom" },
  "apps/flyy_referrals": { name: "referrals" },
  "apps/flyy_tournaments_list": { name: "tournament" },
  "apps/flyy_tournament_detail": { name: "tournament" },
  "apps/flyy_transactions": { name: "transactions" },
  "apps/flyy_rewards": { name: "rewards" },
  "apps/flyy_gift_cards": { name: "gift_cards" },
  "apps/flyy_offers": { name: "offers" },
  "apps/flyy_wallet": { name: "wallet" },
  "apps/raffle_details": { name: "raffleDetail" }
};

/*

| Deeplink | Screen |
|---|---|
| `flyy://apps/leaderboard_history` | `FlyyLeaderBoardHistoryActivity` |
| `flyy://apps/stamp_campaign_new` | `FlyyStampsActivity` |
| `flyy://apps/campaign_home` | `FlyyWinRewardsAndGiftsActivity` |
| `flyy://apps/flyy_bonanza` | `FlyyBonanzaContestActivity` |
| `flyy://apps/quiz_history` | `FlyyHistoryListActivity` |
| `flyy://apps/flyy_quiz_list` | `FlyyAllQuizActivity` |
| `flyy://apps/flyy_quiz_detail` | `FlyyQuizLeaderBoardActivity` |
| `flyy://apps/flyy_quiz_questions` | `FlyyQuizQuestionActivity` |
| `flyy://apps/flyy_custom_quiz_questions` | `FlyyCustomQuizQuestionActivity` |
| `flyy://apps/flyy_referrals` | `FlyyReferralsActivity` |
| `flyy://apps/flyy_product_referrals` | `FlyyProductReferralsActivity` |
| `flyy://apps/flyy_tournaments_list` | `FlyyTournamentListActivity` |
| `flyy://apps/flyy_tournament_history` | `FlyyTournamentHistoryActivity` |
| `flyy://apps/flyy_tournament_detail` | `FlyyTournamentActivity` |
| `flyy://apps/flyy_transactions` | `FlyyAllTransactionActivity` |
| `flyy://apps/flyy_rewards` | `FlyyRewardsActivity` |
| `flyy://apps/flyy_gift_cards` | `FlyyGiftCardsActivity` |
| `flyy://apps/flyy_offers` | `FlyyOffersActivity` |
| `flyy://apps/invite_details` | `FlyyInviteEarnDetailsActivity` |
| `flyy://apps/custom_invite_details` | `FlyyCustomInviteAndEarnActivity` |
| `flyy://apps/bonanza_details` | `FlyyContestLeaderboardActivity` |
| `flyy://apps/bonanza_history` | `FlyyXPHistoryActivity` |
| `flyy://apps/flyy_wallet` | `FlyyWalletActivity` |
| `flyy://apps/challenge_details` | `FlyyChallengesActivity` |
| `flyy://apps/raffle_details` | `FlyyRaffleActivity` |
| `flyy://apps/raffle_history` | `FlyyRaffleHistoryListActivity` |
| `flyy://apps/refer_and_earn` | `FlyyActivityReferAndEarn` |




working in web sdk:

  flyy://flyy_rewards          → rewards                                                                                                
  flyy://flyy_history          → history
  flyy://flyy_wallet           → wallet                                                                                                 
  flyy://flyy_account          → account
  flyy://flyy_transactions     → transactions                                                                                           
  flyy://flyy_redeem           → redeem                                                                                                 
  flyy://flyy_gift_cards       → gift_cards
  flyy://flyy_game_zone        → game_zone                                                                                              
  flyy://flyy_quiz_zone        → quiz_zone                                                                                              
  flyy://flyy_poll_zone        → poll_zone
  flyy://flyy_survey_zone      → survey_zone                                                                                            
  flyy://flyy_trivia_zone      → trivia_zone
  flyy://flyy_referrals        → referrals                                                                                              
  flyy://flyy_tournament       → tournament
                                                                                                                                        
  flyy://apps/quiz_history             → quiz_history                                                                                   
  flyy://apps/stamp_campaign_new       → stamp_campaign
  flyy://apps/flyy_quiz_list           → quiz_zone                                                                                      
  flyy://apps/flyy_quiz_questions      → quiz_questions                                                                                 
  flyy://apps/flyy_custom_quiz_questions → quiz_details_custom
  flyy://apps/flyy_referrals           → referrals                                                                                      
  flyy://apps/flyy_tournaments_list    → tournament                                                                                     
  flyy://apps/flyy_tournament_detail   → tournament
  flyy://apps/flyy_transactions        → transactions                                                                                   
  flyy://apps/flyy_rewards             → rewards
  flyy://apps/flyy_gift_cards          → gift_cards                                                                                     
  flyy://apps/flyy_offers              → offers                                                                                         
  flyy://apps/flyy_wallet              → wallet
  flyy://apps/raffle_details           → raffleDetail
*/

export function navigateDeeplink(router, url) {
  if (!url) {
    console.warn("No deeplink URL provided");
    return;
  }
  if (!url.startsWith("flyy://")) {
    window.open(url, "_blank");
    return;
  }
  const key = url.replace(/^flyy:\/\//, "");
  const target = DEEPLINK_MAP[key] || { name: key.replace(/^flyy_/, "") };
  router
    .replace({ name: "offers" })
    .then(() => router.push(target))
    .catch(err => console.warn("Deeplink route not found:", url, err));
}
